import React from "react";

import Navbar from "../components/navbar/navbar";
import Header from "../components/Header/header";
import SkillsList from "../components/skills-list/skills-list";

const SkillsPage = () => (
  <div>
    <Navbar />
    <Header />
    <SkillsList />
  </div>
);

export default SkillsPage;
